export class SubmitData {
  constructor(
    public title?: string,
    public notes?: string,
    public url?: string,
    public file?: any
  ) {}
}
